/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ShareNetworkIcon16Light } from './ShareNetworkIcon16Light';
import { ShareNetworkIcon16Regular } from './ShareNetworkIcon16Regular';
import { ShareNetworkIcon16Solid } from './ShareNetworkIcon16Solid';
import { ShareNetworkIcon20Light } from './ShareNetworkIcon20Light';
import { ShareNetworkIcon20Regular } from './ShareNetworkIcon20Regular';
import { ShareNetworkIcon20Solid } from './ShareNetworkIcon20Solid';
import { ShareNetworkIcon24Regular } from './ShareNetworkIcon24Regular';
import { ShareNetworkIcon24Solid } from './ShareNetworkIcon24Solid';
import { ShareNetworkIcon32Regular } from './ShareNetworkIcon32Regular';
import { ShareNetworkIcon64Regular } from './ShareNetworkIcon64Regular';
var sizes = {
    16: {
        light: ShareNetworkIcon16Light,
        regular: ShareNetworkIcon16Regular,
        solid: ShareNetworkIcon16Solid,
    },
    20: {
        light: ShareNetworkIcon20Light,
        regular: ShareNetworkIcon20Regular,
        solid: ShareNetworkIcon20Solid,
    },
    24: {
        regular: ShareNetworkIcon24Regular,
        solid: ShareNetworkIcon24Solid,
    },
    32: {
        regular: ShareNetworkIcon32Regular,
    },
    64: {
        regular: ShareNetworkIcon64Regular,
    },
};
export var ShareNetworkIcon = forwardRef('ShareNetworkIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
